/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// /* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
// import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import { useCallback } from "react";
import Debounce from "../../../CommonMethods/Debounce";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGetPatientsQuery } from "../../../slices/patientSlice"
import { setMonitorCurIndex } from "./monitorsSlice";

export default function OrganizationDropdownCorpWithSearch({
    label,
    id,
    placeholder,
    disabled,
    emptyField,
    index,
    selectedOrganizationName,
    setSelectedOrganizationName,
    adminCorpLink,
    selectOrgName,
    setFilterValues,



}
) {
    const ref = useRef();
    const location = useLocation()
    const dispatch = useDispatch()
    const [suggestionsOrg, setSuggestionsOrg] = useState('')
    const [displayEmptyMsg, setDisplayEmptyMsg] = useState('')
    const [skip, setSkip] = useState(false)
    const [suggestions, setSuggestions] = useState('')
    const [queryParams, setQueryParams] = useState(`page_number=1&limit=100`)
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const [isOpen, setisOpen] = useState(false)
    const curIndex = useSelector(state => state?.monitorsSelect?.selectedUsers?.curIndex)
    const { data: organizationData, isFetching, status } = useGetPatientsQuery(
        queryParams, { refetchOnMountOrArgChange: true }
    );


    const handleFetchSubdivision = async (item, index) => {
        const updatedOrgNames = [...selectedOrganizationName]
        updatedOrgNames[index]["patient_name"] = `${item?.last_name} ${item?.first_name} ${item?.middle_name}`,
        updatedOrgNames[index]["patient_id"] = item.patient_id
        setSelectedOrganizationName(updatedOrgNames)
        setFilterValues !== undefined && setFilterValues((prev) => ({
            ...prev, 
            patient_id: item.patient_id, 
            patient_name: `${item?.last_name} ${item?.first_name} ${item?.middle_name}`
        }))
        setisOpen(false);
    }

    const handleChange = (val) => {
        if (val.trim() !== '') {
            const searchValue = `patient_id=*${val.trim()}*;full_name=*${val.trim()}*`;
            setQueryParams(`page_number=1&search_mode=or&search=${encodeURIComponent(searchValue)}`);
        } else {
            setQueryParams(`page_number=1&limit=100`)
        }

    }
    const handleOrganizationListSearch = useCallback(
        Debounce((suggestionsOrg) => handleChange(suggestionsOrg)),
        []
    )
    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });


    // useEffect(() => {
    //     handleOrganizationListSearch('')
    //     setSuggestionsOrg('')


    // }, [isOpen]);


    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        []
    );

    useEffect(() => {
        optimizedFn('')
        handleOrganizationListSearch('')
        setSuggestionsOrg('')
        return () => {
        };
    }, [isOpen]);

    useEffect(() => {
        if (organizationData !== undefined) {
            if (organizationData?.data?.length === 0 || (organizationData?.data?.every(secondObj =>
                selectedOrganizationName.some(firstObj => firstObj.organization_name === secondObj.organization_name)
            ))) {
                setDisplayEmptyMsg('No results found.')
                return
            }
            setDisplayEmptyMsg('')
        }
    }, [organizationData])

    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button
                    ref={buttonRef}
                    onClick={() => { setisOpen(!isOpen), dispatch(setMonitorCurIndex([index])) }}
                    className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                    disabled={disabled}
                    id={id}
                >
                    <p id={id} className={`${(selectOrgName === "" || selectOrgName === undefined) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(selectOrgName === "" || selectOrgName === undefined)
                        ? placeholder
                        : selectOrgName}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                </button>
                <ul className={`py-4 pr-1 pl-4 rounded-lg  bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpen && index === curIndex ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul >
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input
                                        type="text"
                                        autoComplete={"off"}
                                        id={"search"}
                                        placeholder="Search by ID/name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                        onChange={e => { setSuggestionsOrg(e.target.value); optimizedFn(e.target.value) }}
                                        // onChange={(e) => {adminCorpLink!==undefined&&adminCorpLink===true?(handleOrganizationListSearch(e.target.value),setSuggestionsOrg(e.target.value)):handleOrganizationListSearch(e.target.value)}}
                                        value={suggestionsOrg} />
                                    <img src="/images/search_gray.svg" alt="icon" loading='lazy' decoding='async' className="absolute top-[50%] -translate-y-[50%] left-3" />
                                </div>
                            </li>
                        </ul>
                        <ul className="max-h-[calc(100vh-576px)] 2xl:max-h-[calc(100vh-520px)] overflow-auto scrollbar_gray pr-3">
                            <li>
                                {
                                    (displayEmptyMsg === "" && ((isFetching && status !== "fulfilled" && status !== "rejected") || (organizationData === undefined && status !== "fulfilled" && status !== "rejected"))) ? <div className=' h-[400px] relative   px-4 xl rounded-lg mt-3 '>
                                        <div className={`flex justify-center items-center ${suggestionsOrg !== '' ? 'mt-[65px]' : 'mt-[70px]'} `}>
                                            <div className={`loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  ${suggestionsOrg !== '' ? 'mt-[35px]' : 'mt-[55px]'} spin-animation`}></div>
                                        </div>
                                    </div> : displayEmptyMsg === "" ? <ul className={``}>
                                        {!isFetching && organizationData !== undefined && organizationData.data.map((item, i) => {
                                            const isNameExists = selectedOrganizationName.some(org => org.organization_name === item?.organization_name)
                                            return (
                                                (!isNameExists && <li key={item.organization_id} className='flex justify-between items-center p-2'>
                                                    <div className="">
                                                        <p
                                                            id={i + 'organization'}
                                                            data-testid={i + 'dropdown'}
                                                            onClick={() => handleFetchSubdivision(item, curIndex)}
                                                            title={item?.patient_id + "-" + `${item?.last_name} ${item?.first_name} ${item?.middle_name}`}
                                                            htmlFor={i}
                                                            className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                                        >{item?.patient_id} {`${item?.last_name} ${item?.first_name} ${item?.middle_name}`}</p>
                                                    </div>
                                                </li>)
                                            )
                                        })}
                                    </ul> : <p className="mt-2 text-center">{displayEmptyMsg}</p>}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </>
    )
}
